module.exports = __webpack_public_path__ + "img/entertainment-15.866ebf06.jpg";